/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plusonesupto3Inputs */

const en_plusonesupto3 = /** @type {(inputs: Plusonesupto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to this many plus-ones each`)
};

const de_plusonesupto3 = /** @type {(inputs: Plusonesupto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zu so viele Begleitpersonen`)
};

/**
* | output |
* | --- |
* | "Up to this many plus-ones each" |
*
* @param {Plusonesupto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plusonesupto3 = /** @type {((inputs?: Plusonesupto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plusonesupto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plusonesupto3(inputs)
	return de_plusonesupto3(inputs)
});
export { plusonesupto3 as "plusOnesUpTo" }